<script>
	import Icon from "../icons/Icon.svelte";

	export let couriers = [];
	export let formatCurrency = (val) => Number(val || 0).toFixed(2).replace(".", ",");

	export let onOpenCreateModal = () => {};
	export let onOpenEditModal = () => {};
	export let onDeleteCourier = () => {};
	export let onCopyPortalLink = () => {};
	export let onSendPortalWhatsApp = () => {};
</script>

<div class="team-panel">
	<div class="panel-header-row">
		<div class="panel-header-titles">
			<h3>Equipe de Entregadores</h3>
			<p>Cadastro, taxas por corrida, diárias fixas e canais de contato com cada motoboy</p>
		</div>
		<button type="button" class="btn-primary-action" on:click={onOpenCreateModal}>
			<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
			<span>+ Novo Entregador</span>
		</button>
	</div>

	{#if couriers.length === 0}
		<div class="empty-state-box">
			<div class="empty-state-icon"><Icon name="users" size={32} /></div>
			<h3>Nenhum entregador cadastrado</h3>
			<p>Cadastre os motoboys da sua loja para gerenciar remuneração e despacho.</p>
			<button type="button" class="btn-primary-action" on:click={onOpenCreateModal}>
				+ Cadastrar Entregador
			</button>
		</div>
	{:else}
		<div class="table-container">
			<table class="modern-table">
				<thead>
					<tr>
						<th>Entregador</th>
						<th>WhatsApp</th>
						<th>Veículo & Placa</th>
						<th>Modelo de Ganho</th>
						<th>Taxa p/ Corrida</th>
						<th>Diária Fixa</th>
						<th>Status</th>
						<th style="text-align:right;">Ações</th>
					</tr>
				</thead>
				<tbody>
					{#each couriers as courier (courier.id)}
						<tr>
							<td>
								<div class="courier-avatar-name">
									<div class="avatar-circle">{courier.name.slice(0, 2).toUpperCase()}</div>
									<div class="avatar-info">
										<strong>{courier.name}</strong>
										<span class="avatar-sub">Posição #{courier.queue_position || '-'}</span>
									</div>
								</div>
							</td>
							<td>
								{#if courier.phone}
									<a href="https://wa.me/55{courier.phone.replace(/\D/g, '')}" target="_blank" rel="noreferrer" class="wa-link" title="Abrir conversa no WhatsApp">
										<Icon name="whatsapp" size={14} color="#10B981" />
										<span>{courier.phone}</span>
									</a>
								{:else}
									<span class="text-muted">-</span>
								{/if}
							</td>
							<td>
								<div class="vehicle-cell">
									<span class="vehicle-type-label">
										<Icon name={courier.vehicle_type === 'bike' ? 'bike' : courier.vehicle_type === 'carro' ? 'car' : 'motorcycle'} size={13} />
										{courier.vehicle_type === 'bike' ? 'Bicicleta' : courier.vehicle_type === 'carro' ? 'Carro' : 'Moto'}
									</span>
									{#if courier.plate}
										<span class="plate-chip">{courier.plate}</span>
									{/if}
								</div>
							</td>
							<td>
								<span class="fee-type-badge {courier.fee_type === 'daily' ? 'with-daily' : 'fixed-only'}">
									{courier.fee_type === 'daily' ? 'Diária + Taxa' : 'Taxa por Entrega'}
								</span>
							</td>
							<td>
								<strong class="currency-val">R$ {formatCurrency(courier.default_fee)}</strong>
							</td>
							<td>
								<span class="currency-val-secondary">R$ {formatCurrency(courier.daily_rate)}</span>
							</td>
							<td>
								<span class="status-pill {courier.status}">
									<span class="dot"></span>
									{courier.status === 'available' ? 'Disponível' : courier.status === 'busy' ? 'Em Rota' : 'Pausado'}
								</span>
							</td>
							<td style="text-align:right;">
								<div class="actions-cell">
									{#if courier.phone}
										<button type="button" class="btn-tbl share" on:click={() => onCopyPortalLink(courier)} title="Copiar link do portal do motoboy">
											<Icon name="copy" size={13} />
											<span>Link PWA</span>
										</button>
										<button type="button" class="btn-tbl wa-share" on:click={() => onSendPortalWhatsApp(courier)} title="Enviar link do portal no WhatsApp do entregador">
											<Icon name="whatsapp" size={13} color="#10B981" />
										</button>
									{/if}
									<button type="button" class="btn-tbl edit" on:click={() => onOpenEditModal(courier)} title="Editar dados cadastrais">
										<Icon name="edit" size={13} />
										<span>Editar</span>
									</button>
									<button type="button" class="btn-tbl delete" on:click={() => onDeleteCourier(courier)} title="Desativar entregador">
										<Icon name="trash" size={13} />
									</button>
								</div>
							</td>
						</tr>
					{/each}
				</tbody>
			</table>
		</div>
	{/if}
</div>

<style>
	.team-panel {
		background: var(--neutral-surface, #FFFFFF);
		border: 1px solid var(--neutral-border, #E2E8F0);
		border-radius: var(--radius-lg, 16px);
		padding: 24px;
		box-shadow: var(--shadow-card, 0 1px 3px rgba(15, 23, 42, 0.06));
	}

	.panel-header-row {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 22px;
		flex-wrap: wrap;
		gap: 14px;
	}

	.panel-header-titles h3 {
		font-size: 18px;
		font-weight: 800;
		color: var(--text-primary, #0F172A);
		margin: 0 0 4px 0;
		letter-spacing: -0.2px;
	}

	.panel-header-titles p {
		margin: 0;
		font-size: 13px;
		color: var(--text-secondary, #64748B);
	}

	.btn-primary-action {
		background: var(--brand-primary, #FF6A00);
		color: #FFFFFF;
		border: none;
		border-radius: var(--radius-md, 8px);
		padding: 10px 18px;
		font-size: 13px;
		font-weight: 800;
		cursor: pointer;
		display: inline-flex;
		align-items: center;
		gap: 8px;
		transition: background var(--transition-fast, 0.15s ease), transform var(--transition-fast, 0.15s ease);
		box-shadow: 0 2px 8px rgba(255, 106, 0, 0.25);
	}

	.btn-primary-action:hover {
		background: var(--brand-primary-hover, #E85A00);
		transform: translateY(-1px);
	}

	.table-container {
		overflow-x: auto;
		border: 1px solid var(--neutral-border, #E2E8F0);
		border-radius: var(--radius-md, 10px);
	}

	.modern-table {
		width: 100%;
		border-collapse: collapse;
		text-align: left;
		font-size: 13px;
		background: #FFFFFF;
	}

	.modern-table th {
		padding: 12px 16px;
		background: #F8FAFC;
		color: var(--text-secondary, #475569);
		font-weight: 700;
		border-bottom: 1px solid var(--neutral-border, #E2E8F0);
		font-size: 11.5px;
		text-transform: uppercase;
		letter-spacing: 0.5px;
	}

	.modern-table td {
		padding: 14px 16px;
		border-bottom: 1px solid var(--neutral-border-subtle, #F1F5F9);
		color: var(--text-primary, #0F172A);
		vertical-align: middle;
	}

	.modern-table tbody tr:hover {
		background: #FAFAFA;
	}

	.courier-avatar-name {
		display: flex;
		align-items: center;
		gap: 12px;
	}

	.avatar-circle {
		width: 34px;
		height: 34px;
		border-radius: 50%;
		background: var(--brand-primary-soft, #FFF7ED);
		color: var(--brand-primary, #FF6A00);
		font-weight: 800;
		font-size: 11.5px;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-shrink: 0;
		border: 1px solid #FFD8C2;
	}

	.avatar-info {
		display: flex;
		flex-direction: column;
		gap: 2px;
	}

	.avatar-sub {
		font-size: 11px;
		color: var(--text-muted, #94A3B8);
	}

	.wa-link {
		color: #15803D;
		text-decoration: none;
		font-weight: 600;
		display: inline-flex;
		align-items: center;
		gap: 6px;
	}

	.wa-link:hover {
		text-decoration: underline;
	}

	.vehicle-cell {
		display: flex;
		align-items: center;
		gap: 6px;
	}

	.vehicle-type-label {
		display: inline-flex;
		align-items: center;
		gap: 5px;
		color: var(--text-secondary, #475569);
		font-weight: 600;
	}

	.plate-chip {
		background: #0F172A;
		color: #FFFFFF;
		font-size: 10.5px;
		padding: 2px 6px;
		border-radius: 4px;
		font-weight: 700;
	}

	.fee-type-badge {
		background: #F1F5F9;
		padding: 4px 8px;
		border-radius: 6px;
		font-size: 11.5px;
		font-weight: 600;
		color: var(--text-secondary, #475569);
	}

	.fee-type-badge.with-daily {
		background: #FFF7ED;
		color: #C2410C;
		border: 1px solid #FFEDD5;
	}

	.currency-val {
		color: var(--brand-primary, #FF6A00);
		font-weight: 800;
	}

	.currency-val-secondary {
		color: var(--text-secondary, #475569);
		font-weight: 600;
	}

	.actions-cell {
		display: inline-flex;
		gap: 6px;
	}

	.btn-tbl {
		padding: 6px 12px;
		border-radius: 6px;
		border: 1px solid var(--neutral-border, #CBD5E1);
		font-size: 12px;
		font-weight: 600;
		cursor: pointer;
		background: #FFFFFF;
		display: inline-flex;
		align-items: center;
		gap: 5px;
		transition: all 0.15s ease;
	}

	.btn-tbl.edit:hover {
		background: var(--neutral-surface-hover, #F1F5F9);
		border-color: #94A3B8;
	}

	.btn-tbl.delete {
		color: var(--semantic-danger, #DC2626);
		border-color: #FECDD3;
		background: var(--semantic-danger-soft, #FEF2F2);
	}

	.btn-tbl.delete:hover {
		background: #FEE2E2;
		border-color: #F87171;
	}

	.btn-tbl.share {
		background: #F8FAFC;
		border-color: #CBD5E1;
		color: #1E293B;
	}

	.btn-tbl.share:hover {
		background: #EEF2F6;
		border-color: #94A3B8;
	}

	.btn-tbl.wa-share {
		background: #ECFDF5;
		border-color: #A7F3D0;
		color: #059669;
		padding: 6px 9px;
	}

	.btn-tbl.wa-share:hover {
		background: #D1FAE5;
		border-color: #6EE7B7;
	}

	.status-pill {
		display: inline-flex;
		align-items: center;
		gap: 6px;
		padding: 4px 10px;
		border-radius: 9999px;
		font-size: 11.5px;
		font-weight: 700;
	}

	.status-pill.available {
		background: #DCFCE7;
		color: #166534;
		border: 1px solid #BBF7D0;
	}

	.status-pill.busy {
		background: #DBEAFE;
		color: #1E40AF;
		border: 1px solid #BFDBFE;
	}

	.status-pill.offline {
		background: #F1F5F9;
		color: #475569;
		border: 1px solid #E2E8F0;
	}

	.status-pill .dot {
		width: 7px;
		height: 7px;
		border-radius: 50%;
	}

	.status-pill.available .dot { background: #16A34A; }
	.status-pill.busy .dot { background: #2563EB; }
	.status-pill.offline .dot { background: #94A3B8; }

	.empty-state-box {
		padding: 48px 24px;
		text-align: center;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		gap: 12px;
	}

	.empty-state-icon {
		width: 60px;
		height: 60px;
		border-radius: 50%;
		background: #F1F5F9;
		color: #94A3B8;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-bottom: 4px;
	}

	.empty-state-box h3 {
		margin: 0;
		font-size: 17px;
		font-weight: 800;
		color: var(--text-primary, #0F172A);
	}

	.empty-state-box p {
		margin: 0;
		font-size: 13.5px;
		color: var(--text-secondary, #64748B);
		max-width: 380px;
	}

	.text-muted { color: var(--text-muted, #94A3B8); }
</style>
